var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.relations, function (relationKey) {
        return [
          relationKey === "selfRelation"
            ? _c(
                "div",
                {
                  key: relationKey + "_self",
                  staticClass: "gwnl-eval-evaluator__row ellipsis",
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "color-gray-7 lh-50 mr24 yxtbiz-flex-shrink-0 min-width30",
                    },
                    [_vm._v(_vm._s(_vm.$t("pc_gwnl_chart_type_selfLevel")))]
                  ),
                  _vm.showWeight
                    ? _c(
                        "span",
                        { staticClass: "color-gray-10 mr24 min-width30" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.row.selfRelation.weight) +
                              "%\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("yxtbiz-user-name", { attrs: { name: _vm.row.fullname } }),
                ],
                1
              )
            : _c("select-evaluator", {
                key: relationKey,
                attrs: {
                  relationKey: relationKey,
                  relation: _vm.row[relationKey],
                  validate: _vm.validate,
                  row: _vm.row,
                  showWeight: _vm.showWeight,
                  dataPermissionCode: _vm.dataPermissionCode,
                  functionCode: _vm.functionCode,
                  "is-save": _vm.isSave,
                  id: _vm.id,
                  dynamicChoose: _vm.dynamicChoose,
                },
                on: {
                  "update:relation": function ($event) {
                    return _vm.$set(_vm.row, relationKey, $event)
                  },
                  "update-evaluate": function ($event) {
                    return _vm.updateEvaluateVal($event, relationKey)
                  },
                },
              }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }